import { Type } from '@angular/core';

export class DynamicComponent {
  constructor(public key: string, public component: Type<any>, public data: any) { }
}
